type NumericFieldConfig = {
  label?: string
  minExclusive?: number
}

type SubmitContext = {
  addObj: Record<string, unknown>
  config?: {
    editPage?: {
      fields?: Record<string, NumericFieldConfig>
    }
  }
  error: string | null
  save: () => unknown
}

export const submitEditDialog = (context: SubmitContext, missingFields: string[]): boolean => {
  if (missingFields.length > 0) {
    context.error = `Please provide a value for the following fields: ${missingFields.join(', ')}`
    return false
  }

  const fields = context.config?.editPage?.fields ?? {}
  for (const [fieldName, field] of Object.entries(fields)) {
    if (field.minExclusive == null || context.addObj[fieldName] == null) {
      continue
    }

    const value = Number(context.addObj[fieldName])
    if (!Number.isFinite(value) || value <= field.minExclusive) {
      context.error = `${field.label ?? fieldName} must be a finite number greater than ${field.minExclusive}`
      return false
    }

    // PrimeVue emits a number, but normalizing here also keeps pasted/browser
    // supplied numeric strings out of the GraphQL Float mutation payload.
    context.addObj[fieldName] = value
  }

  context.error = null
  context.save()
  return true
}
